var state = {
  visible: false,
  dataSet: {
    rows: []
  },
  menuItem: [],
  left: 0,
  top: 0,
  event: {}
};
var getters = {
  visible: function visible(state) {
    return state.visible;
  },
  menuItem: function menuItem(state) {
    return state.menuItem;
  },
  dataSet: function dataSet(state) {
    return state.dataSet;
  },
  event: function event(state) {
    return state.event;
  }
};
var mutations = {
  SET_VISIBLE: function SET_VISIBLE(state, visible) {
    state.visible = visible;
  },
  SET_MENUITEM: function SET_MENUITEM(state, menuItem) {
    state.menuItem = menuItem;
  },
  SET_DATA: function SET_DATA(state, data) {
    state.dataSet = data;
  },
  SET_EVENT: function SET_EVENT(state, event) {
    state.event = event;
  }
};
var actions = {
  load: function load(_ref, menuItem) {
    var commit = _ref.commit;
    commit('SET_MENUITEM', menuItem);
  },
  open: function open(_ref2, dataSet) {
    var commit = _ref2.commit,
      dispatch = _ref2.dispatch;
    commit('SET_DATA', dataSet);
    dispatch('pointer', dataSet.event);
    commit('SET_VISIBLE', true);
  },
  close: function close(_ref3) {
    var commit = _ref3.commit;
    commit('SET_VISIBLE', false);
  },
  pointer: function pointer(_ref4, e) {
    var commit = _ref4.commit;
    commit('SET_EVENT', e);
  }
};
export default {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
};